module.exports = __webpack_public_path__ + "img/onandon-stamp.17168adc.png";